import { TelephoneFilterModule } from 'filters/telephone.filter';

export const PhoneInputDirectiveModule = angular
    .module('app.directives.phoneInput', [
        TelephoneFilterModule
    ]).directive('vlnPhoneInput', ($filter, $browser) => {
        return {
            require: 'ngModel',
            link: ($scope, $element, $attrs, ngModelCtrl) => {
                let listener = () => {
                    let value = $element.val().replace(/[^0-9]/g, '');
                    $element.val($filter('tel')(value, false));
                    // if checkout form, trigger input to update model value
                    if ($element[0] && !$element[0].form && $element[0].id === 'phone') {
                        $element.trigger('input');
                    }
                };

                ngModelCtrl.$parsers.push((viewValue) => {
                    if (viewValue) return viewValue.replace(/[^0-9]/g, '').slice(0, 17);
                });

                ngModelCtrl.$formatters.push((value) => {
                    if (value) return value.replace(/[^0-9]/g, '').slice(0, 17);
                });

                ngModelCtrl.$render = () => {
                    $element.val($filter('tel')(ngModelCtrl.$viewValue, false));
                    $browser.defer(listener);
                };

                $element.bind('change', listener);
                $element.bind('keydown', (event) => {
                    let key = event.keyCode;

                    // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
                    // This lets us support copy and paste too
                    if (key === 91 || (key > 15 && key < 19) || (key >= 37 && key <= 40)) {
                        return;
                    }
                    $browser.defer(listener); // Have to do this or changes don't get picked up properly
                });

                $element.bind('paste cut', () => {
                    $browser.defer(listener);
                });
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/directives/phoneInput.directive.js